module.exports = __webpack_public_path__ + "img/740000018_4.6cf4e2e4.jpg";